/**
 * @providesModule SKZPrizeBox
 *
 */

import _ from 'lodash';

export type PrizeBoxRecordType = 'CASH' | 'Z' | 'TICKETZ' | 'NONE';

export class PrizeBoxRecord {
  amount: number;
  type: PrizeBoxRecordType;
  color: string;
}

/**
 * @deprecated use PrizeBox instead
 */
export default class SKZPrizeBox extends PrizeBoxRecord {
  constructor(keyValueSource?: Object) {
    super();
    return _.create(SKZPrizeBox.prototype, keyValueSource);
  }

  getColor(): string {
    return this.color || '#4090e2';
  }

  getPrizeTotal(): number {
    return this.amount || 0;
  }

  hasNoPrize(): boolean {
    return this.type === 'NONE';
  }

  isCashAward(): boolean {
    return this.type === 'CASH';
  }

  isTicketzAward(): boolean {
    return this.type === 'TICKETZ';
  }
}
